import { defineRouting } from 'next-intl/routing';

import constants from '../constants/constants.json';

export const routing = defineRouting({
  locales: constants.I18.SUPPORTED_LOCALES,
  defaultLocale: constants.I18.DEFAULT_LOCALE
  // pathnames: {
  //   '/': '/',
  //   '/pathnames': {
  //     de: '/pfadnamen'
  //   }
  // }
});
